import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport } from "@material-ui/data-grid";

import classes from "../../CampaignsDashboard.module.scss";

const BeeswaxReportsTableToolbar: FC = () => {
  return (
    <GridToolbarContainer className={classes.toolbar}>
      <Typography variant="h3">Campaign and Line Item Reports</Typography>

      <div className={classes.toolbarControls}>
        <GridToolbarColumnsButton className={classes.selectMetricsBtn} startIcon={null} />
        <GridToolbarExport className={classes.exportButton} />
      </div>
    </GridToolbarContainer>
  );
};

export default BeeswaxReportsTableToolbar;
